import I18n from '../utilities/translations.js.erb' 
const $t = key => I18n.t(`javascript.packs.payments${key}`)

import { createApp } from 'vue'
import PaymentModal from '../payment_modal';
import MyI18n from '../plugins/my_i18n'
//import { createApp } from 'vue';
document.addEventListener('DOMContentLoaded', () => {
  const  da = document.querySelector("#paymentmodal");

  const cProps = {
		name: da.dataset.name,
		sign: da.dataset.sign,
		text: da.dataset.text,
		agreement: da.dataset.agreement,
		accept: da.dataset.accept,
		next: da.dataset.next,
		page: da.dataset.page,
		paid: da.dataset.paid,
		paying_modal_message: da.dataset.paying_modal_message
  }
  const app = createApp(PaymentModal, cProps);
	app.use(MyI18n);
  //app.config.devtools = true
  //app.config.productionTip = false
  app.mount('#paymentmodal');
});

/*
const app = createApp(
  {
    props: ['signURL'],
  },
  { signURL: 'Evan' }
  )
createApp(Pop).mount("#pop");
*/
